import { render } from "./Edit.vue?vue&type=template&id=cfd49628"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/home/renzon-carnes/htdocs/carnes.renzon.com/public/entregaspro/entregaspro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__